import React from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  VStack,
  Flex,
  Text,
  Avatar,
  Box,
} from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'

interface PendingUsersModalProps {
  isOpen: boolean
  onClose: () => void
  template: any
  pendingUsers: any[]
  isLoading?: boolean
  title?: string
  emptyMessage?: string
}

const PendingUsersModal: React.FC<PendingUsersModalProps> = ({ isOpen, onClose, template, pendingUsers, isLoading = false, title, emptyMessage }) => {
  const { t } = useTranslation()

  const modalTitle = title || t('documents.statistics.pendingUsersTitle')
  const noUsersMessage = emptyMessage || t('documents.statistics.noPendingUsers')

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader height="48px" p="12px 36px 12px 16px" borderBottom="1px" borderColor="solid.50">
          {modalTitle}
        </ModalHeader>
        <ModalCloseButton
          sx={{
            _focus: { outline: 'none', border: 'none', boxShadow: 'none' },
            _hover: { bg: 'solid.50' },
          }}
        />
        <ModalBody pb={6}>
          {isLoading ? (
            <Box textAlign="center" py={8}>
              <Text textStyle="l-s" color="solid.400">
                {t('common.states.loading')}
              </Text>
            </Box>
          ) : pendingUsers.length === 0 ? (
            <Box textAlign="center" py={8}>
              <Text textStyle="l-s" color="solid.400">
                {noUsersMessage}
              </Text>
            </Box>
          ) : (
            <Box
              mt={4}
              maxH="300px"
              overflowY="auto"
            >
              <VStack align="start" spacing={3}>
                {pendingUsers.map((user: any) => (
                  <Flex
                    key={user.id}
                    align="center"
                    width="100%"
                  >
                    <Flex align="center">
                      <Avatar src={user.profile_picture}/>
                      <Box ml={2}>
                        <Text textStyle="h-xs" color="solid.900" mb="6px">
                          {user.first_name} {user.last_name}
                        </Text>
                        <Text textStyle="b-xs" color="solid.500">
                          {user.email || user.work_email || '—'}
                        </Text>
                      </Box>
                    </Flex>
                  </Flex>
                ))}
              </VStack>
            </Box>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default PendingUsersModal
